export default [
    {
        type: "text",
        id: 1,
        items: [
            {
                id: 1,
                type: "medium",
                text: "Name des AG-Leiters / der AG-Leiterin",
            },
        ],
    },
    {
        type: "uni",
        id: 2,
        items: [
            {
                id: 2,
                text: "Durch die Bearbeitung der Übungsaufgaben wurde mein Verständnis der Inhalte gestärkt.",
            },
            {
                id: 3,
                text: "Die Rahmenbedingungen der Arbeitsgemeinschaft halte ich in dieser Form für geeignet (z.B. Anwesenheitspflicht, Präsenzübung, Musterlösung, Vorrechnen).",
            },
            {
                id: 4,
                text: "Mein AG-Leiter/Meine AG-Leiterin war stets gut vorbereitet.",
            },
            {
                id: 5,
                text: "Mein AG-Leiter/Meine AG-Leiterin konnte Kompliziertes verständlich machen.",
            },
            {
                id: 6,
                text: "Mein AG-Leiter/Meine AG-Leiterin war in der Lage, den Hintergrund zu den Themen zu vermitteln.",
            },
            {
                id: 7,
                text: "Mein AG-Leiter/Meine AG-Leiterin hat, innerhalb des von dem Dozenten/der Dozentin vorgegebenen Handlungsspielraums, einen guten Job gemacht.",
            },
            {
                id: 8,
                text: "Der Schwierigkeitsgrad der Übungsfälle ist angemessen.",
            },
            {
                id: 9,
                text: "Der Stoff wird innerhalb der Arbeitsgemeinschaft anhand von Beispielen veranschaulicht.",
            },
            {
                id: 10,
                text: "Das Arbeitstempo und die Anzahl der besprochenen Übungsfälle sind angemessen.",
            },
            {
                id: 11,
                text: "Eine Arbeitsgemeinschaft dieses Leiters/ dieser Leiterin würde ich nochmals besuchen.",
            },
        ],
    },
    {
        type: "text",
        id: 3,
        items: [
            {
                id: 12,
                text: "Besonders gut fand ich:",
            },
            {
                id: 13,
                text: " Störend fand ich:",
            },
            {
                id: 14,
                text: "Verbesserungsvorschläge:",
            },
        ],
    },
];